import styled from 'foundations-theming/utils';
const Flex = styled.div.withConfig({
  displayName: "Flex"
})(["display:flex;width:", ";background-color:", ";padding:", ";align-items:", ";text-align:", ";justify-content:", ";flex-direction:", ";flex-wrap:", ";inline-size:", ";block-size:", ";gap:", ";@media (max-width:768px){flex-direction:", ";}"], ({
  width
}) => width || 'auto', ({
  backgroundColor
}) => backgroundColor || 'transparent', ({
  padding
}) => padding || '0', ({
  align
}) => align || 'center', ({
  textAlign
}) => textAlign || 'center', ({
  justify
}) => justify || 'center', ({
  direction
}) => direction || 'row', ({
  wrap
}) => wrap || 'nowrap', ({
  inlineSize
}) => inlineSize || '100%', ({
  blockSize
}) => blockSize || 'auto', ({
  gap
}) => gap || '0', ({
  direction
}) => direction || 'column');
export default Flex;